import { useCallback, useEffect, useState } from "react"

const ONE_MINUTE_MS = 60_000

export default function useMinuteTicker() {
  const [lastTickTime, setLastTickTime] = useState(null)
  const [intervalId, setIntervalId] = useState(null)

  const startTicker = useCallback(() => {
    if (!intervalId) {
      setIntervalId(setInterval(() => {
        setLastTickTime(Date.now())
      }, ONE_MINUTE_MS))
    }
  }, [intervalId])

  const stopTicker = useCallback(() => {
    if (intervalId) {
      clearInterval(intervalId)
      setIntervalId(null)
    }
  }, [intervalId])

  useEffect(() => {
    // Make sure to stop the ticker when the component unmounts
    return () => {
      stopTicker()
    }
  }, [stopTicker])

  return { lastTickTime, startTicker, stopTicker }
}
